import React from 'react'
import Navbar1 from '../../layout/Navbar';
import Section from './section';

const layout6 = () => {
  return (
    <React.Fragment>
      <Navbar1 />
      <Section />
    </React.Fragment>
  )
}

export default layout6;